import { Skeleton } from "@material-ui/lab";
import { Grid, makeStyles } from "@material-ui/core";
import layoutConstants from "../constants/layoutConstants";

const useStyles = makeStyles(() => ({
    skeletonLoader: {
        borderRadius: "8px",
    },
}));

export function DashboardHeadlineLoader({ headlines }) {

    const classes = useStyles();
    const headlineArray = Array.apply(null, Array(headlines));

    return (
        <>
            {headlineArray?.map(
                (headline, index) =>
                    !headline && (
                        <Grid item key={index}>
                            <Skeleton
                                className={classes.skeletonLoader}
                                variant="rect"
                                height={layoutConstants.headlineTileHeight}
                                width={layoutConstants.headlineTileWidth}
                            />
                        </Grid>
                    )
            )}
        </>
    );
}
